import React from "react";
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GamePlayMobileHeaderBarComponent} from "../../game-play-mobile-header-bar.component";
import {GamePlayMobileHeaderBarClockComponent} from "../../parts/clock/game-play-mobile-header-bar-clock.component";
import {observer} from "mobx-react";
import {GamePlayMobileHeaderTopLeftContainerBox} from "../../boxes/top-section/game-play-mobile-header-top-left-container.box";
import {BottomLeftSectionBox} from "./boxes/bottom-section/left/bottom-left-section.box";
import {BottomRightSectionBox} from "./boxes/bottom-section/right/bottom-right-section.box";
import {AmountComponent} from "./parts/amount.component";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {TopSectionBox} from "./boxes/top-section/top-section.box";

interface SpainGamePlayMobileHeaderBarComponentProps {
    gameContext: IGameContextViewModel;
}

export const SpainGamePlayMobileHeaderBarComponent = observer(
    class SpainGamePlayMobileHeaderBarComponent extends OrbitComponent<SpainGamePlayMobileHeaderBarComponentProps> {

        private _renderTopSection = () => {
            return (
                <GamePlayMobileHeaderTopLeftContainerBox>
                    <TopSectionBox>
                        <GamePlayMobileHeaderBarClockComponent/>
                    </TopSectionBox>
                </GamePlayMobileHeaderTopLeftContainerBox>

            );
        }

        private _renderBottomSection = () => {
            const gameSessionData = this.props.gameContext.gameSessionData;
            return (
                <GamePlayMobileHeaderTopLeftContainerBox>
                    <BottomLeftSectionBox>
                        <AmountComponent label={this.services.translation.translate('TOTAL_BANKROLL')} amount={gameSessionData.bankroll}/>
                        <AmountComponent label={this.services.translation.translate('GAME_SESSION_BALANCE')} amount={gameSessionData.totalWins - gameSessionData.totalBets}/>
                    </BottomLeftSectionBox>
                    <BlankHorizontalSeparatorBox multiplier={2}/>
                    <BottomRightSectionBox>
                        <AmountComponent label={this.services.translation.translate('TOTAL_WINS')} amount={gameSessionData.totalWins}/>
                        <AmountComponent label={this.services.translation.translate('TOTAL_BETS')} amount={gameSessionData.totalBets}/>
                    </BottomRightSectionBox>
                </GamePlayMobileHeaderTopLeftContainerBox>
            )
        }

        render() {
            return (
                <GamePlayMobileHeaderBarComponent gameContext={this.props.gameContext}
                                                  renderTopLeftSection={this._renderTopSection}
                                                  renderBottomSection={this._renderBottomSection}/>

            )
        }
    }
);